export default __webpack_public_path__ + "static/media/pose_eat01.c0fd8c11.png";